import sliders from './components/sliders'
import galleries from './components/galleries'
import plans from './components/boat-plans'
import performance from './components/performance'
import sticky from './components/sticky'
import mobile from './components/mobile-menu'
import scroll from './components/scroll-transitions'
import video from './components/video-modal'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { gsap } from 'gsap'
import { tns } from 'tiny-slider/src/tiny-slider'
import mega from './components/mega-menu'

gsap.registerPlugin(ScrollTrigger)

window.tns = tns
window.gsap = gsap

window.addEventListener('load', () => {
    sliders()
    galleries()
    plans()
    performance()
    sticky()
    mobile()
    scroll()
    video()
    mega()
}, false)
